/**
 * `/` is the public landing gate — it redirects signed-in users to the surface
 * that matches their role (business owners land on their dashboard). Shopper
 * surfaces must link to SHOPPER_HOME instead so a business or driver account
 * browsing the storefront isn't bounced out of it.
 */
export const SHOPPER_HOME = '/shop';
export const BUSINESS_HOME = '/business';

export const ROUTES = {
  shopperHome: SHOPPER_HOME,
  boutiques: '/boutiques',
  categories: '/categories',
  sale: '/sale',
  faq: '/faq',
  shipping: '/shipping',
  returns: '/returns',
  contact: '/contact',
  about: '/about',
  careers: '/careers',
  press: '/press',
  blog: '/blog',
  terms: '/terms',
  privacy: '/privacy',
} as const;
